module.exports = __webpack_public_path__ + "assets/8f9dfbb80e160a04103ba7ef88ac8cc3.svg";